import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { Injectable, Injector } from '@angular/core';

import { HelpConfig } from '@config/help-config';
import { CandidatoAgendamentoAdicionadoModel } from '@core/models/agendamento/candidato-agendamento-adicionado.model';
import { Observable } from 'rxjs';
import { AulaModel } from '@core/models/agendamento/aula.model';

@Injectable({
  providedIn: 'root',
})
export class CandidatoAgendamentoService extends BaseResourceService<CandidatoAgendamentoAdicionadoModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.SCHEDULING_API}candidatoagendamento`, injector);
  }

  addCandidateToClass(classId: number, payload): Observable<CandidatoAgendamentoAdicionadoModel> {
    return this._httpClient.post<CandidatoAgendamentoAdicionadoModel>(`${this._url}/${classId}/candidato`,payload);
  }

  getCandidateByClass(classId: number): Observable<CandidatoAgendamentoAdicionadoModel[]> {
    return this._httpClient.get<CandidatoAgendamentoAdicionadoModel[]>(`${this._url}/${classId}/candidatos`);
  }

  getClassCandidate(classId: number): Observable<CandidatoAgendamentoAdicionadoModel[]> {
    return this._httpClient.get<CandidatoAgendamentoAdicionadoModel[]>(`${this._url}/${classId}/candidatos`);
  }
 
  getCandidateSchedule(matriculaIdExterno: number): Observable<AulaModel[]> {
    return this._httpClient.get<AulaModel[]>(`${this._url}?matriculaIdExterno=${matriculaIdExterno}`);
  }

  removeCandidateFromClass(candidateScheduleId): Observable<null> {
    const path = `${this._url}/${candidateScheduleId}/removercandidato`;
    return this._httpClient.delete<null>(`${path}`);
  }

  multiplo(query: string) {
    const END_POINT = `/multiplo?${query}`
    return this._httpClient.post<any>(`${this._url}${END_POINT}`,null);
  }
}
